export default __webpack_public_path__ + "static/media/content1-background-xs.0ede9f45.png";